import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HomeService } from '../services/home.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgToastService } from 'ng-angular-popup';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
})
export class OrdersComponent implements OnInit {
  orders: any;
  noData: boolean = false;
  UpdateDocForm!: FormGroup;
  selectedFile: File | null = null;
  orderId!: number;
  isTrade: boolean = false;
  deliveryDetails: any;
  otherform!: FormGroup;
  isSelf: boolean = true;
  selectedFileone: File | null = null;
  urlImage: any;
  selectedFile_otherperson: any;
  rejectionReason: any;
  DeliveryStatusDetails: any;
  deliveryDetailsAbove500: any;
  above500Details: any;
  orderIdAbove500: any;
  uploadedImagePath: any;
  currentPage: number = 1;
limit: number = 10;
totalCount: number = 0;
totalPages: number = 0;
  currentOrderType:any;


isCoinOrder: boolean = false;
coinOrdersList: any[] = [];
coinSummary: any = null;
coinMetalType: string = 'Gold';
coinCurrentPage: number = 1;
coinLimit: number = 10;
coinTotalCount: number = 0;
coinTotalPages: number = 0;
coinNoData: boolean = false;



  heading = 'Order History';

coinOrders:any;

page = 1;
  spinner: any;
  pageHeading:any;
  selectedMetal:any;

  constructor(
    private home: HomeService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private toast: NgToastService,
    private auth: AuthService,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private route: ActivatedRoute,private homeService: HomeService,
  ) {
    this.UpdateDocForm = this.fb.group({
      transaction_image: ['', [Validators.required]],
      transation_id: [
        '',
        [Validators.required, Validators.pattern(/^.{12,}$/)],
      ],
      order_id: [''],
    });

    this.otherform = this.fb.group({
      order_id: ['', [Validators.required]],
      other_person_name: ['', [Validators.required]],
      other_person_number: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{10}$')],
      ],
      other_person_id_card_number: ['', [Validators.required]],
      other_person_doc: ['', [Validators.required]],
    });
  }

  otherPersonFile(event: any) {
    this.selectedFile_otherperson = event.target.files[0];
    if (this.selectedFile_otherperson) {
      const formData = new FormData();
      formData.append('other_person_doc', this.selectedFile_otherperson);
      console.log(
        'image',
        formData.append('other_person_doc', this.selectedFile_otherperson)
      );
      // Log the selected file details
      console.log('Selected file:', this.selectedFile_otherperson);
    }
  }
  onOtherFormSubmit() {
    // Create a new FormData object to hold the entire form data, including the file
   const formData = new FormData();

  Object.keys(this.otherform.value).forEach((key) => {
    if (key !== 'other_person_doc') {
      formData.append(key, this.otherform.get(key)?.value);
    }
  });

  if (this.selectedFile_otherperson) {
    formData.append('other_person_doc', this.selectedFile_otherperson);
  }


  // const orderId = this.orderId || this.orderIdAbove500;
  // formData.append('order_id', orderId);

  formData.forEach((value, key) => {
    console.log(key, ':', value);
  });
    this.home.userNewPersonDetailspost(formData).subscribe(
      (res: any) => {
        this.orderStatusUpdate(this.orderId || this.orderIdAbove500);
        this.loadOrders('BUY');
        this.otherform.reset();
        window.location.reload();

        this.toast.success({
          detail: 'Success',
          summary: res.msg,
          position: 'topCenter',
        });
      },
      (err) => {
        this.toast.error({
          detail: 'Oops!',
          summary: err.error.msg,
          position: 'topCenter',
        });
      }
    );
  }
  resetOtherForm() {
    window.location.reload();
  }

  isUploadDisabled: boolean = false
  onFileSelectedReceipt(event: any) {
    this.selectedFile = event.target.files[0];


    
    if (this.selectedFile) {
        // Validate file type
        const validImageTypes = ['image/png', 'image/jpeg'];
        const validImageExtensions = ['.png', '.jpg', '.jpeg'];
        const validVideoTypes = ['video/mp4', 'video/avi', 'video/mkv'];
        const fileExtension = this.selectedFile.name.split('.').pop()?.toLowerCase(); // Get file extension

         console.log('File Type:', this.selectedFile.type);       // ADD
        console.log('File Extension:', fileExtension);  

        // Check if the selected file is a video
        if (validVideoTypes.includes(this.selectedFile.type)) {
            this.isUploadDisabled = true; // Disable the upload button
            this.toast.error({ detail: 'Error', summary: 'Video files are not allowed for upload.', duration: 5000 });
            event.target.value = ''; // Reset the input
            return;
        }

        // Check if the selected file is not a valid image
        if (!validImageTypes.includes(this.selectedFile.type) || 
            !validImageExtensions.includes(`.${fileExtension}`)) {
            this.isUploadDisabled = true; // Disable the upload button
            this.toast.error({ detail: 'Error', summary: 'Please select a valid image file (PNG or JPEG).', duration: 5000 });
            event.target.value = ''; // Reset the input
            return;
        }

        // If a valid image is selected, enable the upload button
        this.isUploadDisabled = false;

        // Proceed with file upload
        const formData = new FormData();
        formData.append('transaction_image', this.selectedFile);

        this.home.imgUpload(formData).subscribe(
            (res: any) => {
               console.log('UPLOAD RESPONSE', res);
                
    this.UpdateDocForm.patchValue({
      transaction_image: res.data.transaction_image
    });


  this.UpdateDocForm.get('transaction_image')?.markAsTouched();
    this.UpdateDocForm.get('transaction_image')?.updateValueAndValidity();
                  console.log(
    'AFTER PATCH',
    this.UpdateDocForm.value.transaction_image
  ); // ADD THIS
        console.log('Keys:', Object.keys(res));            // ADD THIS
                // this.UpdateDocForm.get('transaction_image')?.setValue(res.transaction_image);
            },
            (error: any) => {
                console.error('Upload failed:', error);
                this.toast.error({ detail: 'Upload Error', summary: 'An error occurred while uploading the image. Please try again.', duration: 5000 });
            }
        );
    } else {
        this.isUploadDisabled = true; // Disable the upload button if no file is selected
    }
}








  // onGetId(id: number) {
  //   console.log(id);
  //   this.UpdateDocForm.get('order_id')?.setValue(id);
  //   this.orders.forEach((ele: any) => {
  //     if (ele.id === id) {
  //       this.rejectionReason = ele.rejection_reason;
  //     }
  //   });
  // }
  onGetId(id: number) {
  console.log(id);
  this.UpdateDocForm.get('order_id')?.setValue(id);

  const sourceArray = this.isCoinOrder ? this.coinOrdersList : this.orders;

  sourceArray.forEach((ele: any) => {
    if (ele.id === id) {
      this.rejectionReason = ele.rejection_reason;
    }
  });
}
  pickUpMsg(id: number) {
    this.home.deliveryMsg(id).subscribe((res: any) => {
      this.deliveryDetails = res.deliveryDetails;
      console.log(this.deliveryDetails);
    });
  }
//   onSubmit() {
//     console.log('FINAL PAYLOAD', this.UpdateDocForm.value);
//  if (!this.selectedFile) {
//     this.toast.error({
//       detail: 'Error',
//       summary: 'Please select a receipt image'
//     });
//     return;
//   }

//   const formData = new FormData();

//   formData.append('transaction_image', this.selectedFile);
//   formData.append('transation_id', this.UpdateDocForm.value.transation_id);
//   formData.append('order_id', this.UpdateDocForm.value.order_id);
//     this.home.receiptUpdate(this.UpdateDocForm.value).subscribe(
//       (res: any) => {
//         this.loadOrders('BUY');
//         this.UpdateDocForm.reset();
//         this.toast.success({
//           detail: 'Success',
//           summary: res.msg,
//           position: 'topCenter',
//         });
//       },
//       (err) => {
//         this.toast.error({
//           detail: 'Ooops!',
//           summary: err.error.msg,
//           position: 'topCenter',
//         });
//       }
//     );
//   }

// onSubmit() {
// debugger;
//   if (!this.selectedFile) {
//     this.toast.error({
//       detail: 'Error',
//       summary: 'Please select receipt image'
//     });
//     return;
//   }

//   const formData = new FormData();

//   formData.append(
//     'transaction_image',
//     this.selectedFile,
//     this.selectedFile.name
//   );

//   formData.append(
//     'transaction_id',
//     this.UpdateDocForm.value.transation_id
//   );

//   formData.append(
//     'order_id',
//     this.UpdateDocForm.value.order_id
//   );

//   this.home.receiptUpdate(formData).subscribe(
//     (res: any) => {

//       this.loadOrders('BUY');
//       this.UpdateDocForm.reset();

//       this.toast.success({
//         detail: 'Success',
//         summary: res.msg,
//         position: 'topCenter'
//       });

//     },
//     (err) => {

//       this.toast.error({
//         detail: 'Oops!',
//         summary: err.error.message || err.error.msg,
//         position: 'topCenter'
//       });

//     }
//   );
// }

onSubmit() {

  if (!this.selectedFile) {
    this.toast.error({
      detail: 'Error',
      summary: 'Please select receipt image'
    });
    return;
  }

  const formData = new FormData();

  formData.append(
    'transaction_image',
    this.selectedFile,
    this.selectedFile.name
  );

  formData.append(
    'transaction_id',
    this.UpdateDocForm.value.transation_id
  );

  formData.append(
    'order_id',
    this.UpdateDocForm.value.order_id
  );

  // ---------- COIN REUPLOAD (#exampleModalGold, isCoinOrder = true) ----------
  // Same API as the initial coin upload (onSubmitCoin) — called directly, no chaining.
  if (this.isCoinOrder) {

    formData.append('metal_type', this.coinMetalType);

    this.home.uploadCoinTransaction(formData).subscribe(
      (res: any) => {

        this.loadCoinOrders(this.coinMetalType);
        this.UpdateDocForm.reset();

        this.toast.success({
          detail: 'Success',
          summary: res.msg,
          position: 'topCenter'
        });

      },
      (err) => {

        this.toast.error({
          detail: 'Oops!',
          summary: err.error.message || err.error.msg,
          position: 'topCenter'
        });

      }
    );

    return;
  }

  // ---------- NORMAL ORDER FLOW (isCoinOrder = false) ----------
  this.home.receiptUpdate(formData).subscribe(
    (res: any) => {

      this.loadOrders('BUY');
      this.UpdateDocForm.reset();

      this.toast.success({
        detail: 'Success',
        summary: res.msg,
        position: 'topCenter'
      });

    },
    (err) => {

      this.toast.error({
        detail: 'Oops!',
        summary: err.error.message || err.error.msg,
        position: 'topCenter'
      });

    }
  );
}






  selfConform() {
    this.orderStatusUpdate(this.orderId || this.orderIdAbove500); // Assuming this is synchronous
    this.toast.success({
      detail: 'Success',
      summary: 'Confirmation to pick up the order yourself.',
      position: 'topCenter',
    });

    this.loadOrders('BUY'); // Assuming this is synchronous

    // Delay the page reload to give time for toast notification
    setTimeout(() => {
      window.location.reload();
    }, 1500); // Adjust this delay if needed
  }

  // submitDeliveryBoy(){
  //   this.orderStatusUpdate(this.orderId || this.orderIdAbove500);
  //   this.toast.success({
  //     detail: 'Success',
  //     summary: 'Confirmation to pick up the order yourself.',
  //     position: 'topCenter',
  //   });

  //   this.loadOrders('BUY');
  //   setTimeout(() => {
  //     window.location.reload();
  //   }, 1500);
  // }

  // submitcourier(){
  //   this.orderStatusUpdate(this.orderId || this.orderIdAbove500);
  //   this.toast.success({
  //     detail: 'Success',
  //     summary: 'Confirmation to pick up the order yourself.',
  //     position: 'topCenter',
  //   });

  //   this.loadOrders('BUY');
  //   setTimeout(() => {
  //     window.location.reload();
  //   }, 1500);
  // }
showMetalButtons = false;

//   ngOnInit(): void {



//   this.route.queryParams.subscribe((params) => {

//     if (params['orderType'] === 'Coins') {

//       this.isCoinOrder = true;

//       if (params['from'] === 'header') {

//         this.showMetalButtons = true;
//         this.selectedMetal = 'Gold';
//         this.loadCoinOrders('Gold');

//       } else {

//         this.showMetalButtons = false;
//         this.selectedMetal = params['metalType'] || 'Gold';
//         this.loadCoinOrders(this.selectedMetal);

//       }

//     } else {

//       this.isCoinOrder = false;
//       this.showMetalButtons = false;
//       this.loadOrders('BUY');

//     }

//   });
//     this.loadOrders('BUY');
//  this.route.queryParams.subscribe(params => {

//     if (params['orderType'] === 'Coins') {

//       this.isCoinOrder = true;

//       if (params['from'] === 'header') {

//         this.showMetalButtons = true;

//         this.selectedMetal = 'Gold';
//         this.loadCoinOrders('Gold');

//       } else {

//         this.showMetalButtons = false;

//         this.selectedMetal = params['metalType'];

//         this.loadCoinOrders(this.selectedMetal);

//       }

//     } else {

//       this.isCoinOrder = false;
//       this.showMetalButtons = false;

//       this.loadOrders('BUY');

//     }

//   });
    
//   this.route.queryParams.subscribe((params) => {
//     console.log('QUERY PARAMS:', params);
//     const orderType = params['orderType'];
//     const metalType = params['metalType'];

//     console.log('orderType:', orderType, 'metalType:', metalType);

//     if (orderType === 'Coins') {
//       console.log('COIN ORDER BRANCH HIT');
//       this.isCoinOrder = true;
//       this.coinMetalType = metalType || 'Gold';
//       this.pageHeading = `${this.coinMetalType} Coin Orders`;
//       this.loadCoinOrders(this.coinMetalType);
//     } else {
//       console.log('NORMAL ORDER BRANCH HIT');
//       this.isCoinOrder = false;
//       this.loadOrders('BUY');
//     }
//   });

//   }

// ngOnInit(): void {

//   this.route.queryParams.subscribe((params) => {

//     const orderType = params['orderType'];

//     const metalType = params['metalType'];

//     if (orderType === 'Coins') {

//       this.isCoinOrder = true;

//       if (orderType) {

  
//         this.showMetalButtons = true;

//         this.selectedMetal = 'Gold';
//         this.coinMetalType = 'Gold';
//         this.pageHeading = 'Gold Coins History';

//         this.loadCoinOrders('Gold');

//       } else {

//         // Place order nundi vachinappudu buttons hide
//         this.showMetalButtons = false;

//         this.selectedMetal = metalType || 'Gold';
//         this.coinMetalType = this.selectedMetal;
//         this.pageHeading = `${this.selectedMetal} Coins History`;

//         this.loadCoinOrders(this.selectedMetal);

//       }

//     } else {

//       // Normal Orders
//       this.isCoinOrder = false;
//       this.showMetalButtons = false;

//       this.loadOrders('BUY');

//     }

//   });

// }

ngOnInit(): void {

  this.route.queryParams.subscribe((params) => {

    const orderType = params['orderType'];
    const metalType = params['metalType'];

    if (orderType === 'Coins') {

      this.isCoinOrder = true;

      if (!metalType) {

        // Generic /orders?orderType=Coins entry (metalType లేకుండా) — buttons చూపించాలి, default Gold
        this.showMetalButtons = true;

        this.selectedMetal = 'Gold';
        this.coinMetalType = 'Gold';
        this.pageHeading = 'Gold Coins History';

        this.loadCoinOrders('Gold');

      } else {

        // Place order nundi vachinappudu (metalType present) — buttons hide
        this.showMetalButtons = false;

        this.selectedMetal = metalType;
        this.coinMetalType = metalType;
        this.pageHeading = `${metalType} Coins History`;

        this.loadCoinOrders(metalType);

      }

    } else {

      // Normal Orders
      this.isCoinOrder = false;
      this.showMetalButtons = false;

      this.loadOrders('BUY');

    }

  });

}
  updateBuy(event: any) {
    this.loadOrders(event.target.value);
  }
  // loadOrders(orderType: string): void {

  //   if (orderType != 'BUY') {
  //     this.isTrade = true;
  //   } else {
  //     this.isTrade = false;
  //   }
  //   this.home.ordersGet(orderType).subscribe(
  //     (res: any) => {
  //       this.orders = res;
  //         this.orders = res.sort((a: any, b: any) =>
  //       new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  //     );
  //       this.noData = !res || res.length === 0; // Set noData flag if no orders or response is empty
  //     },
  //     (error) => {}
  //   );
  // }

loadOrders(orderType: string): void {
    this.currentOrderType = orderType;
  this.isTrade = orderType != 'BUY';

  this.home.ordersGet(orderType, this.currentPage, this.limit).subscribe(
    (res: any) => {
      console.log('Orders FULL RES:', res);  // check structure

      // handle based on response shape
      if (res?.data) {
        // paginated response
        this.orders = res.data;
        this.totalCount = res?.pagination?.total || 0;      
      this.totalPages = res?.pagination?.totalPages || 0;  
      } else {
        // non-paginated (plain array)
        this.orders = Array.isArray(res) ? res : [];
        this.totalCount = this.orders.length;
        this.totalPages = Math.ceil(this.totalCount / this.limit);
      }

      // sort by date
    

      this.noData = this.orders.length === 0;
    },
    (error) => {
      console.error('Error fetching orders:', error);
    }
  );
}


// coinMetalType = 'Gold';

loadCoinOrders(metalType: string): void {

  this.coinMetalType = metalType;

  console.log('Calling Coin API:', metalType);

  this.home.getCoinOrders(
    metalType,
    this.coinCurrentPage,
    this.coinLimit
  ).subscribe({

    next: (res: any) => {

      console.log('Coin Response', res);

      this.coinOrdersList = res.data || [];

  this.coinSummary = res.summary || {};

  this.coinCurrentPage = res.summary?.page || 1;

  this.coinLimit = res.summary?.limit || 10;

  this.coinTotalPages = res.summary?.total_pages || 1;

  this.coinTotalCount = res.total_coin_orders || 0;

  this.coinNoData = this.coinOrdersList.length === 0;

      this.pageHeading =
        metalType === 'Gold'
          ? 'Gold Coins History'
          : 'Silver Coins History';

    },

    error: (err) => {

      console.log(err);

    }

  });

}
onPageChange(page: number) {
  this.currentPage = page;
  // call with current orderType — store it as variable
  this.loadOrders(this.currentOrderType);
  window.scrollTo(0, 0);
}
  orderpicker(event: any) {
    console.log(event.target.value);
    if (event.target.value === 'self') {
      this.isSelf = true;
    } else {
      this.isSelf = false;
    }
  }
  getOrderId(id: number, pro: any) {
    this.orderId = id;
    this.otherform.get('order_id')?.setValue(id);
    this.pickUpMsg(id);
    this.DeliveryStatusDetails = pro;
    console.log(this.DeliveryStatusDetails);
  }
  orderStatusUpdate(id: number) {
    this.home
      .updateOrderStatus({
        order_id: id,
        status: 5,
      })
      .subscribe((res: any) => {});
  }

  getOrderIdAbove500(id: any, pro: any) {
    this.orderIdAbove500 = id;
    this.otherform.get('order_id')?.setValue(id);
    this.pickUpMsg(id);
    this.above500Details = pro;
    this.home.deliveryMsg(id).subscribe((res: any) => {
      this.deliveryDetailsAbove500 = res.deliveryDetails;
      console.log(this.above500Details);
      console.log(this.deliveryDetailsAbove500);
    });
  }

  submitDeliveryBoy() {
    this.home
      .updateOrderStatus({
        order_id: this.orderId || this.orderIdAbove500,
        status: 4, // Set status to 4 for delivery boy
      })
      .subscribe(
        (res: any) => {
          this.toast.success({
            detail: 'Success',
            summary: 'Order dispatched via delivery boy.',
            position: 'topCenter',
          });

          this.loadOrders('BUY');
          setTimeout(() => {
            window.location.reload();
          }, 1500); // Adjust the delay if needed
        },
        (err) => {
          this.toast.error({
            detail: 'Oops!',
            summary: 'Failed to update the order status.',
            position: 'topCenter',
          });
        }
      );
  }

  submitcourier() {
    this.home
      .updateOrderStatus({
        order_id: this.orderId || this.orderIdAbove500,
        status: 4, // Set status to 4 for courier
      })
      .subscribe(
        (res: any) => {
          this.toast.success({
            detail: 'Success',
            summary: 'Order dispatched via courier.',
            position: 'topCenter',
          });

          this.loadOrders('BUY');
          setTimeout(() => {
            window.location.reload();
          }, 1500); // Adjust the delay if needed
        },
        (err) => {
          this.toast.error({
            detail: 'Oops!',
            summary: 'Failed to update the order status.',
            position: 'topCenter',
          });
        }
      );
  }

  isZoomed: boolean = false;

  toggleZoom(): void {
    this.isZoomed = !this.isZoomed;
  }

// Helper for template: "50g x1, 100g x1"
onCoinPageChange(page: number): void {
  this.coinCurrentPage = page;
    this.loadCoinOrders(this.coinMetalType);
  // this.loadCoinOrders(this.coinMetalType);
  window.scrollTo(0, 0);
}

getCoinItemsSummary(items: any[]): string {
  if (!items || !items.length) return '-';
  return items.map((i) => `${i.coin_weight}g x${i.quantity}`).join(', ');
}

onSubmitCoin() {

  if (!this.selectedFile) {
    this.toast.error({
      detail: 'Error',
      summary: 'Please select receipt image'
    });
    return;
  }

  const formData = new FormData();

  formData.append(
    'transaction_image',
    this.selectedFile,
    this.selectedFile.name
  );

  formData.append(
    'transaction_id',
    this.UpdateDocForm.value.transation_id
  );

  formData.append(
    'order_id',
    this.UpdateDocForm.value.order_id
  );
  formData.append(
  'metal_type',
  this.coinMetalType
);

  this.home.uploadCoinTransaction(formData).subscribe(
    (res: any) => {

      this.loadCoinOrders(this.coinMetalType);
      this.UpdateDocForm.reset();

      this.toast.success({
        detail: 'Success',
        summary: res.msg,
        position: 'topCenter'
      });

    },
    (err) => {

      this.toast.error({
        detail: 'Oops!',
        summary: err.error.message || err.error.msg,
        position: 'topCenter'
      });

    }
  );
}

changeMetal(type: string): void {
  this.selectedMetal = type;
  this.coinMetalType = type;
  this.loadCoinOrders(type);
}

}
